export const PRICING_BILLING_CYCLE = {
    None: 0,
    Monthly: 1,
    Annual: 2
}

export const PRICING_CHARGE_MODEL = {
    None: 0,
    FixedPrice: 1,
    PerUser: 2
}

export const PRICING_TIER = {
    Free: 0,
    Basic: 1,
    Standard: 2,
    Premium: 3
}

export const PRICING_DEFAULT_PLAN_MODEL = {
    Id: null,
    Tier: null,
    TierName: null || 'Basic',
    Description: null,
    Features: null,
    Plans: []
}

export const PRICING_DEFAULT_PLAN_ITEM_MODEL = {
    IsActive: true,
    PlanId: null,
    Price: 0,
    BillingCycle: null,
    BillingCycleName: null
}
